import { isPlatform } from '@ionic/vue';
import { Keyboard } from '@capacitor/keyboard';
import store from '../store';

export function init() {
  if (isPlatform('capacitor')) {
    Keyboard.setAccessoryBarVisible({ isVisible: true });

    Keyboard.addListener('keyboardWillShow', () => {
      store.dispatch('setKeyboardOpen', true);
    });

    Keyboard.addListener('keyboardDidHide', () => {
      store.dispatch('setKeyboardOpen', false);
    });
  }
}
